// src/utils/fileUrl.ts
const FILES_URL = (
    import.meta.env.VITE_API_FILES ||
    import.meta.env.VITE_FILES_URL ||
    "https://cdn.tinderone.app"
).replace(/\/$/, "");
const S3_FILES_URL = (
    import.meta.env.VITE_S3_FILES_URL ||
    import.meta.env.VITE_CDN_V2_URL ||
    "https://cdn-v2.tinderone.app"
).replace(/\/$/, "");
const API_URL = (import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

function normalizeFileRef(input: unknown): string {
    if (input == null) return "";
    if (typeof input === "number" && Number.isFinite(input)) return String(Math.trunc(input));
    if (typeof input === "string") return input.trim();
    if (typeof input === "object") {
        const source = input as Record<string, unknown>;
        for (const key of ["url", "cdn_url", "src", "file_url", "image", "photo", "fid", "file_id", "file_fid", "media_fid", "path"] as const) {
            const value = source[key];
            if (typeof value === "string" && value.trim()) return value.trim();
            if (typeof value === "number" && Number.isFinite(value)) return String(Math.trunc(value));
        }
    }
    return "";
}

export function fileUrl(id?: unknown) {
    const value = normalizeFileRef(id);
    if (!value) return "/default-avatar.png";
    if (/^(https?:|blob:|data:)/.test(value)) return value;
    if (value.startsWith("/api/")) return API_URL ? `${API_URL}${value}` : value;
    if (/^\/?users\/photos\//i.test(value)) {
        return `${S3_FILES_URL}/${value.replace(/^\//, "")}`;
    }

    const fileId = value.replace(/^\/?files\//, "").replace(/^\//, "");
    return `${FILES_URL}/${fileId}`;
}

console.log("VITE_PWA_DEV =", import.meta.env.VITE_PWA_DEV);
console.log("VITE_FILES_URL =", import.meta.env.VITE_FILES_URL);
